export const siteCanonicalUrl = 'https://oficina-ia.app'

/** Entrada dos alunos já cadastrados por Arthur na plataforma compartilhada. */
export const studentPortalUrl = 'https://portal.oficina-ia.app/'

export const youtubeChannelUrl = 'https://www.youtube.com/@arthur-oficina-ia'

export const contactWhatsAppUrl = 'https://wa.me/554197719248'

/** Link do WhatsApp com uma mensagem apenas preparada: ela só é enviada se a pessoa decidir enviá-la. */
export const whatsAppUrlFor = (message: string): string =>
  `${contactWhatsAppUrl}?text=${encodeURIComponent(message)}`

/** Mensagem dos links de WhatsApp das páginas que não têm mensagem própria (botão flutuante e rodapé). */
export const siteWhatsAppMessage = 'Olá, Arthur. Vim pelo site da Oficina IA e quero conversar.'

export const legalBusiness = Object.freeze({
  businessName: 'English Craft Ensino de Idiomas Ltda.', // termo-ok: razão social usada exclusivamente no rodapé
  cnpj: '59.557.947/0001-40',
  address: 'Alameda Princesa Izabel, 1849 - Bigorrilho, Curitiba/PR - CEP 80730-080',
  email: 'arthur@oficina-ia.app',
})

/** Caminho secundário do individual: dúvida antes de marcar a primeira conversa. */
export const individualWhatsAppMessage =
  'Olá, Arthur. Tenho uma dúvida sobre o acompanhamento individual na Oficina IA.'

export const individualWhatsAppUrl =
  `${contactWhatsAppUrl}?text=${encodeURIComponent(individualWhatsAppMessage)}`

/**
 * Página de reservas da primeira conversa (gratuita, 30 minutos) no Google Agenda, aberta em nova aba.
 * Evento configurado em 14/09/2026; o nome que aparece na reserva é administrado por Arthur no Google.
 */
export const individualBookingUrl = 'https://calendar.app.google/PA7crmvkKeFGqdFW9'

/** Rótulo único do convite principal do site, em todas as páginas (decisão de Arthur, 18/09/2026). */
export const bookingLabel = 'Marcar a primeira conversa'

/** Páginas sobre possibilidades, primeira conversa e acompanhamento. */
export const potencialPath = '/o-que-da-para-fazer-com-ia/'
export const conversaPath = '/primeira-conversa/'
export const acompanhamentoPath = '/como-funciona-o-acompanhamento/'

/** Página de valores do acompanhamento individual. */
export const valoresPath = '/valores/'

export const valoresWhatsAppMessage =
  'Olá, Arthur. Vim pela página de valores da Oficina IA e quero entender as condições.'

/** Passo a passo "Como instalar o Codex no Windows": página de busca. */
export const codexWindowsPath = '/como-instalar-o-codex-no-windows/'

export const codexWindowsWhatsAppMessage =
  'Olá, Arthur. Vim pela página do Codex no Windows e quero saber sobre o acompanhamento.'

/**
 * Página de venda do acompanhamento individual para empreendedores (28/09/2026).
 * Substitui /50-mais/; /50-mais/ e /60-mais/ recebem 301 direto para cá (public/_redirects).
 */
export const empreendedoresPath = '/ia-para-empreendedores/'

export const empreendedoresWhatsAppMessage =
  'Olá, Arthur. Nunca usei IA no meu negócio e quero saber sobre o acompanhamento individual.'

export const legalPaths = Object.freeze({
  privacy: '/privacidade/',
  terms: '/termos/',
})
